/* eslint-disable */
require('./dashboard')
require('./diagnostic')
require('./eye')
require('./password')
require('./settings')
require('./user')
